function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
import cloneDeep from 'lodash/cloneDeep';
import * as EWalletHelper from '../helpers/ewallet.reducer.helper';
import { find, propEq } from 'ramda';
import LocaleKeys from '../../locales/keys';
import { i18n, BoolHelper, RamdaHelper } from 'invision-core';
import { PAYMENT_METHOD_STATUSES, SUPPORTED_PAYMENT_INSTRUMENT_TYPES } from './../../components/customer/ewallet/ewallet.constants';
import { parseAdditionalProperties, ExternalBillAdditionalProperties, externalBillAdditionalPropertyDescriptors, PaymentInstrumentTypeAdditionalProperties } from '../helpers/payment.instrument.additional.property.parser';
import * as CreditCardHelper from '../../utilities/credit.card.helper';
export var COMPARISON_RESULT = {
  BEFORE: -1,
  AFTER: 1,
  SAME: 0
};
var BALANCE_IN_POINTS_KEY = 'balance_in_points';
var POINTS_DESCRIPTOR_KEY = 'points_descriptor';
var REQUIRE_BILLING_ADDRESS_KEY = 'require_billing_address';
export var PaymentInstrumentActionable = /*#__PURE__*/_createClass(function PaymentInstrumentActionable() {
  _classCallCheck(this, PaymentInstrumentActionable);
  this.canBlocklist = false;
  this.isDirectSource = false;
  this.isShareable = false;
  this.canCreate = false;
  this.canOrder = false;
  this.supportsAutoPay = false;
});
export var comparePaymentInstrumentViewModelByTypeAndCreation = function comparePaymentInstrumentViewModelByTypeAndCreation(p1, p2) {
  var typeOrder1 = EWalletHelper.getPaymentMethodTypeSortOrder(p1.Type);
  var typeOrder2 = EWalletHelper.getPaymentMethodTypeSortOrder(p2.Type);
  if (typeOrder1 < typeOrder2) {
    return COMPARISON_RESULT.BEFORE;
  } else if (typeOrder1 > typeOrder2) {
    return COMPARISON_RESULT.AFTER;
  }
  var created1 = p1.Created;
  var created2 = p2.Created;

  // Sort created in reversed order
  if (created1 > created2) {
    return COMPARISON_RESULT.BEFORE;
  } else if (created1 < created2) {
    return COMPARISON_RESULT.AFTER;
  }
  return COMPARISON_RESULT.SAME;
};
var paymentInstrumentCanBeEdited = function paymentInstrumentCanBeEdited(paymentInstrument) {
  return EWalletHelper.isEditablePaymentInstrumentType(paymentInstrument.Type) && !paymentInstrumentIsRemovedOrSuspended(paymentInstrument);
};
var paymentInstrumentIsRemovedOrSuspended = function paymentInstrumentIsRemovedOrSuspended(paymentInstrument) {
  return paymentInstrument.Status === PAYMENT_METHOD_STATUSES.REMOVED || paymentInstrument.Status === PAYMENT_METHOD_STATUSES.SUSPENDED;
};
var externalGiftCardTypeConfiguredForPoints = function externalGiftCardTypeConfiguredForPoints(cardType) {
  var balanceInPointsProperty = RamdaHelper.findByKey(BALANCE_IN_POINTS_KEY, cardType.AdditionalProperties);
  return balanceInPointsProperty && balanceInPointsProperty.Value === 'True';
};
var getExternalGiftCardTypePointsDescriptor = function getExternalGiftCardTypePointsDescriptor(cardType) {
  var pointsDescriptorProperty = RamdaHelper.findByKey(POINTS_DESCRIPTOR_KEY, cardType.AdditionalProperties);
  return pointsDescriptorProperty && pointsDescriptorProperty.Value ? pointsDescriptorProperty.Value : '';
};
var getPaymentInstrumentMetaData = function getPaymentInstrumentMetaData(paymentInstrumentType, paymentInstrumentTypes) {
  return find(propEq("".concat(paymentInstrumentType), 'Value'))(paymentInstrumentTypes);
};
export var cardTypeRequiresBillingAddress = function cardTypeRequiresBillingAddress(cardType) {
  var billingAddressRequiredProperty = RamdaHelper.findByKey(REQUIRE_BILLING_ADDRESS_KEY, cardType.AdditionalProperties);
  return !!billingAddressRequiredProperty && BoolHelper.getBoolOrDefault(billingAddressRequiredProperty.Value, false);
};
export var paymentInstrumentToViewModel = function paymentInstrumentToViewModel(customerPaymentInstrument, paymentTypes, actionablesPerPaymentType) {
  var paymentInstrument = cloneDeep(customerPaymentInstrument);
  var allTypes = paymentTypes.allTypes,
    creditCardTypes = paymentTypes.creditCardTypes,
    externalBillTypes = paymentTypes.externalBillTypes,
    externalGiftCardTypes = paymentTypes.externalGiftCardTypes;
  var paymentInstrumentType = paymentInstrument.Type.toString();
  var paymentInstrumentSubType;
  var additionalPropertiesModel = {};
  var additionalPropertiesParseDescriptor = [];
  if (paymentInstrumentType === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.CREDIT_CARD && paymentInstrument.CreditCard && paymentInstrument.CreditCard.Type) {
    var cardTypeName = CreditCardHelper.findCardType(creditCardTypes, paymentInstrument.CreditCard.Type.toString());
    paymentInstrument.CreditCard.typeName = cardTypeName ? cardTypeName : paymentInstrument.TypeName;
    paymentInstrumentSubType = paymentInstrument.CreditCard.Type;
  } else if (paymentInstrumentType === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_GIFT_CARD && paymentInstrument.ExternalGiftCard) {
    var cardTypeMetadata = externalGiftCardTypes.find(function (c) {
      return String(c.Value) === String(paymentInstrument.ExternalGiftCard.Type);
    });
    paymentInstrument.ExternalGiftCard.typeName = cardTypeMetadata && cardTypeMetadata.Name ? cardTypeMetadata.Name : paymentInstrument.TypeName;
    if (cardTypeMetadata) {
      if (externalGiftCardTypeConfiguredForPoints(cardTypeMetadata)) {
        paymentInstrument.ExternalGiftCard.formattedBalance = "".concat(paymentInstrument.ExternalGiftCard.Balance, " ").concat(getExternalGiftCardTypePointsDescriptor(cardTypeMetadata));
      }
      paymentInstrument.requiresBillingAddress = cardTypeRequiresBillingAddress(cardTypeMetadata);
      paymentInstrumentSubType = paymentInstrument.ExternalGiftCard.Type;
    }
  } else if (paymentInstrumentType === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.EXTERNAL_BILL && paymentInstrument.ExternalBill) {
    if (paymentInstrument.ExternalBill.Type && paymentInstrument.ExternalBill.Type > 0) {
      var ebillType = externalBillTypes.find(function (c) {
        return String(c.Value) === String(paymentInstrument.ExternalBill.Type);
      });
      if (ebillType) {
        paymentInstrument.TypeName = ebillType.Name;
      }
    }
    paymentInstrumentSubType = paymentInstrument.ExternalBill.Type;
    additionalPropertiesModel = new ExternalBillAdditionalProperties();
    additionalPropertiesParseDescriptor = externalBillAdditionalPropertyDescriptors;
  } else if (paymentInstrumentType === SUPPORTED_PAYMENT_INSTRUMENT_TYPES.STORED_VALUE_ACCOUNT && paymentInstrument.StoredValueAccount) {
    if (paymentInstrument.StoredValueAccount.LoyaltyCard) {
      paymentInstrument.TypeName = i18n.translate(LocaleKeys.E_WALLET.STORED_VALUE_ACCOUNT.LOYALTY_CARD);
    }
  }
  paymentInstrument.Locked = EWalletHelper.isLockedPaymentInstrument(paymentInstrument);
  var defaultPermission = new PaymentInstrumentTypeAdditionalProperties();
  var permission = actionablesPerPaymentType[paymentInstrumentType] || defaultPermission;
  paymentInstrument.actionables = new PaymentInstrumentActionable();
  paymentInstrument.actionables.canCreate = permission.userCreatable;
  paymentInstrument.actionables.canEdit = permission.userCreatable && paymentInstrumentCanBeEdited(paymentInstrument);
  paymentInstrument.actionables.canBlocklist = permission.canBlocklist;
  paymentInstrument.actionables.canOrder = permission.userOrderable;
  paymentInstrument.actionables.isShareable = permission.isShareable;
  paymentInstrument.actionables.isDirectSource = permission.isDirectSource;
  paymentInstrument.actionables.supportsAutoPay = permission.supportsAutoPay;
  if (paymentInstrumentSubType) {
    var paymentTypeMetaData = getPaymentInstrumentMetaData(paymentInstrumentSubType, allTypes);
    if (paymentTypeMetaData) {
      paymentInstrument.paymentInstrumentMetaData = parseAdditionalProperties(additionalPropertiesModel, paymentTypeMetaData.AdditionalProperties, additionalPropertiesParseDescriptor);
    }
  }
  return paymentInstrument;
};
export var isPaymentInstrumentTypeAvailable = function isPaymentInstrumentTypeAvailable(paymentInstrumentTypeCodeValue, allPaymentInstrumentTypes, isAllPaymentInstrumentTypesAvailable, availablePaymentInstrumentTypesMap) {
  var isInAllPaymentInstrumentTypes = allPaymentInstrumentTypes.some(function (type) {
    return type.Value === paymentInstrumentTypeCodeValue;
  });
  return !!(isInAllPaymentInstrumentTypes && (isAllPaymentInstrumentTypesAvailable || availablePaymentInstrumentTypesMap && availablePaymentInstrumentTypesMap[paymentInstrumentTypeCodeValue]));
};